import DecimalService from '../decimalService';

const subtractNumbersAsDecimals = (a: number, b: number): number => {
    const decimalA = DecimalService.parse(a);
    const decimalB = DecimalService.parse(b);
    const difference = DecimalService.subtract(decimalA, decimalB);

    return DecimalService.toNumber(difference);
};

export default subtractNumbersAsDecimals;
